import { createContext, useContext, useEffect, useState } from "react";
import { syncMasterData, syncMasterDataWithOptions } from '../services/masterCache';
import { hasSessionToken } from "../services/authSession";

const GlobalOpsiContext = createContext();
const EMPTY_GLOBAL_OPSI = {
  opsiCabang: [],
  opsiMT: [],
  opsiBan: [],
  opsiSumber: [],
  opsiAkun: [],
  opsiSubAkun: [],
  opsiSuplier: [],
  opsiKapasitas: [],
  opsiKategori: [],
  opsiUkuran: [],
  opsiMerkMT: [],
};

export function GlobalOpsiProvider({ children }) {
    const [globalOpsi, setGlobalOpsi] = useState(EMPTY_GLOBAL_OPSI);
    const [hydrated, setHydrated] = useState(false);

    const refreshGlobalOpsi = async () => {
      const data = await syncMasterData();
      setGlobalOpsi({ ...EMPTY_GLOBAL_OPSI, ...(data || {}) });
      console.log("syncronized");
      return data;
   };

    const manualResyncGlobalOpsi = async (options = {}) => {
      const data = await syncMasterDataWithOptions({ force: true, ...options });
      setGlobalOpsi({ ...EMPTY_GLOBAL_OPSI, ...(data || {}) });
      return data;
    };

  useEffect(() => {
    try {
      const localMaster = JSON.parse(sessionStorage.getItem("globalOpsi") || localStorage.getItem("globalOpsi")) || {};
      if (localStorage.getItem("globalOpsi")) {
        sessionStorage.setItem("globalOpsi", localStorage.getItem("globalOpsi"));
        localStorage.removeItem("globalOpsi");
      }
      setGlobalOpsi({ ...EMPTY_GLOBAL_OPSI, ...localMaster });
    } catch {
      setGlobalOpsi(EMPTY_GLOBAL_OPSI);
    } finally {
      setHydrated(true);
    }
  }, []);

  useEffect(() => {
    if (!hydrated) return;
    if (!hasSessionToken()) return;
    refreshGlobalOpsi().catch(() => {});
  }, [hydrated]);
  
  return (
    <GlobalOpsiContext.Provider value={{globalOpsi, refreshGlobalOpsi, manualResyncGlobalOpsi}}>
      {children}
    </GlobalOpsiContext.Provider>
  );
}

export function useGlobalOpsi() {
  return useContext(GlobalOpsiContext);
}
